// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-setting-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 56rem;
  height: 40rem;
  max-width: 90vw;
  max-height: 85vh;
}

.settings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-default);
  flex-shrink: 0;
}

.settings-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.close-icon {
  color: var(--ion-color-medium-grey);
  font-size: 1.5rem;
}

.profile-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}
@media (max-width: 576px) {
  .profile-container {
    display: block;
    overflow-y: auto;
  }
}

.settings-nav {
  display: flex;
  flex-direction: column;
  width: 14rem;
  min-width: 14rem;
  padding: 0.75rem 0;
  border-right: 1px solid var(--border-default);
}
@media (max-width: 576px) {
  .settings-nav {
    width: 100%;
    min-width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--border-default);
  }
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 1.25rem;
  cursor: pointer;
  transition: background 0.1s;
}
.nav-item ion-icon {
  font-size: 1.25rem;
  color: var(--ion-color-medium-grey);
  flex-shrink: 0;
}
.nav-item span {
  font-size: 0.85rem;
  font-weight: 400;
  color: var(--ion-color-dark-grey);
  white-space: nowrap;
}
.nav-item:hover {
  background: var(--surface-tertiary);
}
.nav-item:active {
  background: var(--surface-active);
}
.nav-item.active {
  background: rgba(18, 100, 163, 0.08);
}
.nav-item.active ion-icon, .nav-item.active span {
  color: var(--ion-color-primary);
}
.nav-item.active:hover {
  background: rgba(18, 100, 163, 0.12);
}
.nav-item.active:active {
  background: rgba(18, 100, 163, 0.18);
}

.lang-item {
  cursor: default;
  align-items: flex-start;
}
.lang-item:hover {
  background: transparent;
}

.lang-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
}

.lang-select {
  font-size: 0.8rem;
  width: 100%;
  color: var(--text-primary);
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: 6px;
  padding: 0.35rem 1.75rem 0.35rem 0.6rem;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
          appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23616061' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.4rem center;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.lang-select:hover {
  border-color: var(--border-default);
}
.lang-select:focus {
  border-color: var(--color-accent);
  box-shadow: 0 0 0 2px rgba(18, 100, 163, 0.15);
}

.external-link-icon {
  font-size: 0.7rem !important;
  margin-left: -0.25rem;
}

.settings-content {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
}
.settings-content ::ng-deep .setting-container {
  padding: 0;
}
@media (max-width: 576px) {
  .settings-content {
    width: 100%;
  }
}

.settings-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 18rem;
}
.settings-loader-container .profile-spinner {
  width: 2.5rem;
  height: 2.5rem;
  border: 3px solid var(--border-default);
  border-top-color: var(--ion-color-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/profile/profile.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,8CAAA;EACA,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AACJ;;AAEA;EACI,mCAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,OAAA;EACA,gBAAA;AACJ;AACI;EALJ;IAMQ,cAAA;IACA,gBAAA;EAEN;AACF;;AACA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;AAEJ;AAAI;EARJ;IASQ,WAAA;IACA,eAAA;IACA,kBAAA;IACA,8CAAA;EAGN;AACF;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;AAGJ;AADI;EACI,kBAAA;EACA,mCAAA;EACA,cAAA;AAGR;AAAI;EACI,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;AAER;AACI;EACI,mCAAA;AACR;AAEI;EACI,iCAAA;AAAR;AAGI;EACI,oCAAA;AADR;AAGQ;EACI,+BAAA;AADZ;AAIQ;EACI,oCAAA;AAFZ;AAKQ;EACI,oCAAA;AAHZ;;AAQA;EACI,eAAA;EACA,uBAAA;AALJ;AAOI;EACI,uBAAA;AALR;;AASA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AANJ;;AASA;EACI,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,kCAAA;EACA,uCAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;UAAA,gBAAA;EACA,wQAAA;EACA,4BAAA;EACA,wCAAA;EACA,gDAAA;AANJ;AAQI;EACI,mCAAA;AANR;AASI;EACI,iCAAA;EACA,8CAAA;AAPR;;AAWA;EACI,4BAAA;EACA,qBAAA;AARJ;;AAWA;EACI,OAAA;EACA,gBAAA;EACA,eAAA;AARJ;AAUI;EACI,UAAA;AARR;AAWI;EATJ;IAUQ,WAAA;EARN;AACF;;AAWA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AARJ;AAUI;EACI,aAAA;EACA,cAAA;EACA,uCAAA;EACA,0CAAA;EACA,kBAAA;EACA,oCAAA;AARR;;AAYA;EACI;IAAK,yBAAA;EARP;AACF","sourcesContent":[".profile-setting-wrapper {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    width: 56rem;\n    height: 40rem;\n    max-width: 90vw;\n    max-height: 85vh;\n}\n\n.settings-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem 1.25rem;\n    border-bottom: 1px solid var(--border-default);\n    flex-shrink: 0;\n}\n\n.settings-title {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin: 0;\n}\n\n.close-icon {\n    color: var(--ion-color-medium-grey);\n    font-size: 1.5rem;\n}\n\n.profile-container {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n\n    @media(max-width: 576px) {\n        display: block;\n        overflow-y: auto;\n    }\n}\n\n.settings-nav {\n    display: flex;\n    flex-direction: column;\n    width: 14rem;\n    min-width: 14rem;\n    padding: 0.75rem 0;\n    border-right: 1px solid var(--border-default);\n\n    @media(max-width: 576px) {\n        width: 100%;\n        min-width: 100%;\n        border-right: none;\n        border-bottom: 1px solid var(--border-default);\n    }\n}\n\n.nav-item {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.6rem 1.25rem;\n    cursor: pointer;\n    transition: background 0.1s;\n\n    ion-icon {\n        font-size: 1.25rem;\n        color: var(--ion-color-medium-grey);\n        flex-shrink: 0;\n    }\n\n    span {\n        font-size: 0.85rem;\n        font-weight: 400;\n        color: var(--ion-color-dark-grey);\n        white-space: nowrap;\n    }\n\n    &:hover {\n        background: var(--surface-tertiary);\n    }\n\n    &:active {\n        background: var(--surface-active);\n    }\n\n    &.active {\n        background: rgba(18, 100, 163, 0.08);\n\n        ion-icon, span {\n            color: var(--ion-color-primary);\n        }\n\n        &:hover {\n            background: rgba(18, 100, 163, 0.12);\n        }\n\n        &:active {\n            background: rgba(18, 100, 163, 0.18);\n        }\n    }\n}\n\n.lang-item {\n    cursor: default;\n    align-items: flex-start;\n\n    &:hover {\n        background: transparent;\n    }\n}\n\n.lang-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    min-width: 0;\n}\n\n.lang-select {\n    font-size: 0.8rem;\n    width: 100%;\n    color: var(--text-primary);\n    background: var(--surface-primary);\n    border: 1px solid var(--border-default);\n    border-radius: 6px;\n    padding: 0.35rem 1.75rem 0.35rem 0.6rem;\n    cursor: pointer;\n    outline: none;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23616061' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.4rem center;\n    transition: border-color 0.15s, box-shadow 0.15s;\n\n    &:hover {\n        border-color: var(--border-default);\n    }\n\n    &:focus {\n        border-color: var(--color-accent);\n        box-shadow: 0 0 0 2px rgba(18, 100, 163, 0.15);\n    }\n}\n\n.external-link-icon {\n    font-size: 0.7rem !important;\n    margin-left: -0.25rem;\n}\n\n.settings-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 1.5rem;\n\n    ::ng-deep .setting-container {\n        padding: 0;\n    }\n\n    @media(max-width: 576px) {\n        width: 100%;\n    }\n}\n\n.settings-loader-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 18rem;\n\n    .profile-spinner {\n        width: 2.5rem;\n        height: 2.5rem;\n        border: 3px solid var(--border-default);\n        border-top-color: var(--ion-color-primary);\n        border-radius: 50%;\n        animation: spin 0.8s linear infinite;\n    }\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
